import { createAsyncThunk } from '@reduxjs/toolkit';
import { postDuplicateItems } from 'scenes/ProjectBank/services/postDuplicateItems.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { loadProjectBankFolderContents } from './loadProjectBankFolderContents.thunk';

export const duplicateItems = createAsyncThunk(
  'projectBank/duplicateItems',
  async ({ filePermissions = [], targetProjectId, targetParentFilePermissionId }, { getState, dispatch, rejectWithValue }) => {
    const state = getState();

    const projectId = selectSelectedProjectId(state);

    try {
      const filePermissionIds = filePermissions.map(fp => fp.id)

      const response = await postDuplicateItems(
        { filePermissionIds, targetProjectId, projectIds: [projectId, targetProjectId], targetParentFilePermissionId },
        projectId
      );

      // NOTE: If we add functionality to duplicate into the same folder, we need to refresh the folder contents
      // if (response) {
      //   const currentFolderId = state.selectedFolderId;
      //   const currentlyInTargetFolder = response.targetFolder && response.targetFolder === currentFolderId;

      //   if (currentlyInTargetFolder) {
      //     dispatch(loadProjectBankFolderContents({ folderId: currentFolderId }));
      //   }
      // }

      return response;

    } catch (error) {
      const status = error?.response?.status || 0;
      const data = error?.response?.data || null;
      const message =
        (data && (data.message || data.error)) ||
        error?.message ||
        'Duplicate failed';

      return rejectWithValue({ status, message });
    }

  }
);
